var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M12.89 4.523A5.966 5.966 0 0 1 13.918 7H16v2h-2.083a5.967 5.967 0 0 1-1.026 2.477l1.473 1.473-1.414 1.414-1.473-1.473A5.968 5.968 0 0 1 9 13.917V16H7v-2.083a5.966 5.966 0 0 1-2.477-1.026L3.05 14.364 1.636 12.95l1.473-1.473A5.968 5.968 0 0 1 2.083 9H0V7h2.083a5.968 5.968 0 0 1 1.026-2.477L1.636 3.05 3.05 1.636l1.474 1.473A5.968 5.968 0 0 1 7 2.083V0h2v2.083a5.968 5.968 0 0 1 2.476 1.026l1.474-1.473 1.414 1.414-1.473 1.473ZM8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7d145be6bd9ab44c693268aa80d32601.svg";
export { ForwardRef as ReactComponent };